import { c as _c } from "react/compiler-runtime";
import { Navigate, useSearchParams } from "react-router";

// /search?q= — отдельной страницы поиска нет: поиск витрины — это каталог с
// ?search= (строка поиска в шапке ведёт туда же). На проде /search отвечает
// 301 ещё на сервере (шлюз, services/seo.ts), здесь — переход внутри SPA.
export function SearchRedirect() {
  const $ = _c(2);
  const [params] = useSearchParams();
  const q = (params.get("q") ?? params.get("search") ?? params.get("query") ?? "").trim();
  const t0 = q ? `/catalog?search=${encodeURIComponent(q)}` : "/catalog";
  let t1;
  if ($[0] !== t0) {
    t1 = <Navigate to={t0} replace={true} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}